/**
 * Initial state factory for the "posts" (feed) Vuex module.
 *
 * Returned as a function (rather than a plain object) so Vuex gets a fresh,
 * unshared state tree per store instantiation.
 */
export default () => ({
  // Saved drafts for the current channel (compose box "Drafts" list)
  draftPosts: [],
  // Draft currently loaded into the compose box for editing
  draftDataPost: null,
});
